import { Autocomplete, Checkbox, Chip, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

interface IProps {
  id: string;
  items: Array<any>;
  itemKey: string;
  itemText: string;
  labelText: string;
  multiSelect: boolean;
  placeHolderText: string;
  controlWidth?: number;
  labelPaddingTop?: string;
  defaultValue?: any;
  onChange: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isRequired?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  allowEmptyValue?: boolean;
  limitTags?:number;
  helperText?:string;
}
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutoCompleteSelect = ({
  id,
  items,
  itemKey,
  itemText,
  labelText,
  multiSelect,
  placeHolderText,
  controlWidth,
  labelPaddingTop,
  defaultValue,
  onChange,
  isRequired = false,
  hasError = false,
  disabled = false,
  allowEmptyValue = false,
  limitTags = 1,
  helperText = ''
}: IProps) => {
  // Set defaults
  if (placeHolderText == null) placeHolderText = 'Select option';
  if (!itemKey) itemKey = 'id';
  if (!items) items = [];

  if (!defaultValue) {
    if (multiSelect) {
      defaultValue = [];
    } else {
      defaultValue = '';
    }
  }

  // console.log('FuelSelect', { defaultValue, items, multiSelect });

  //   const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [selectedValues, setSelectedValues] = useState(defaultValue);

  // const loading = open && options.length === 0;

  const handleChange = (event, values) => {
    // console.log('handleChange', { values });
    if (multiSelect) {
      setSelectedValues(values);
      onChange(values);
    } else {
      setSelectedValue(values);
      onChange(values);
    }
  };

  const removeOption = (id) => {};

  const getOptionLabel = (option) => {
    if (option && option[itemText]) {
      return option[itemText].toString();
    }
    return '';
  };

  useEffect(() => {
    setSelectedValue(defaultValue);
    setSelectedValues(defaultValue);
    // console.log('defaultValue', defaultValue)
  }, [defaultValue]);

  return (
    <Autocomplete
      className="unitypredict-autocomplete"
      multiple={multiSelect}
      options={items}
      id={id}
      disableCloseOnSelect={multiSelect ? multiSelect : false}
      getOptionLabel={getOptionLabel}
      value={multiSelect ? selectedValues : selectedValue}
      limitTags={limitTags}
      disabled={disabled}
      disableClearable={!allowEmptyValue}
    
      // getOptionSelected={(option, value) => option.id === value.id}
      renderOption={(props, option, { selected }) => {
        if (multiSelect) {
          return (
            <li {...props} key={option[itemKey]}>
              <Checkbox
                size="small"
                color="success"
                style={{
                  transform: 'scale(.6)',
                  marginRight: 8,
                }}
                checked={selected}
              />
              {option[itemText]}
            </li>
          );
        }
        return (
          <li {...props} key={option[itemKey]}>
            {option[itemText]}
          </li>
        );
      }}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={labelText}
          placeholder={placeHolderText}
          required={isRequired}
          error={hasError}
          helperText={helperText}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off',
          }}
        />
      )}
      isOptionEqualToValue={(option, value) => value === undefined || value === '' || option[itemKey] === value[itemKey]}
    />
  );
};

export default AutoCompleteSelect;
